export default function enqueueSnackbarWithSound(enqueueSnackbar, playDone,
                                                 playSoundIfActive, message, variant) {
  enqueueSnackbar(message, {
    variant: variant || 'success'
  });
  if (playDone && playSoundIfActive){
    playSoundIfActive(playDone);
  }
}
